<div class="card card--box"
    [class.card--box--dropped]="feeling['dropped'] && !feeling['dropping']"
    [class.card--box--dropping]="feeling['dropping']"
    [class.card--box--disabled]="feeling['disabled']"
    [attr.dataId]="feeling['disabled'] ? null : feeling['index']" [style.left]="(feeling['x'].toString() + 'px')"
    [style.top]="(feeling['y'].toString() + 'px')" [style.width]="(feeling['width'].toString() + 'px')"
    [style.transform]="(feeling['dropped'] && !feeling['dropping']) ? 'scale(' + scale + ')' : 'scale(1)'"
    [style.height]="(feeling['height'].toString() + 'px')"
    [style.z-index]="feeling['disabled'] ? 2 : feeling['z-index']">
    {{ feeling['description_' + lang] }}
</div>
<div *ngIf="feeling['connectionWidth']" class="connection"
    [class.connection--disabled]="feeling['disabled']"
    [style.left]="(feeling['connectionX'].toString() + 'px')"
    [style.top]="((feeling['y'] + feeling['height'] / 2).toString() + 'px')"
    [style.width]="(isMobile ? (feeling['connectionWidth']*1.25).toString() : feeling['connectionWidth'].toString()) + 'px'"
    [style.height]="'2px'" [style.z-index]="feeling['connection-index'] > 1 ? feeling['connection-index'] - 1 : 1"></div>
